import { render, staticRenderFns } from "./DamageField.vue?vue&type=template&id=073ffd04&scoped=true"
import script from "./DamageField.vue?vue&type=script&lang=ts"
export * from "./DamageField.vue?vue&type=script&lang=ts"
import style0 from "./DamageField.vue?vue&type=style&index=0&id=073ffd04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073ffd04",
  null
  
)

export default component.exports